export default {
  termsVersion: "2.7.2",
  showVersion: true,
  version: "2.27.248",
};
